import { Box, Container, Typography, Grid, Card, CardContent, Avatar } from '@mui/material';
import { FormatQuote as QuoteIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';

const Testimonial = ({ quote, author }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
  >
    <Card 
      elevation={2}
      sx={{
        height: '100%',
        bgcolor: 'background.paper',
        '&:hover': {
          transform: 'translateY(-4px)',
          transition: 'transform 0.3s ease-in-out',
        },
      }}
    >
      <CardContent sx={{ p: 4 }}>
        <Box sx={{ display: 'flex', mb: 2 }}>
          <QuoteIcon color="primary" sx={{ fontSize: 40 }} />
        </Box>
        <Typography variant="body1" paragraph sx={{ mb: 3, fontStyle: 'italic' }}>
          "{quote}"
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar 
            sx={{ 
              bgcolor: 'primary.main',
              width: 48,
              height: 48,
              mr: 2
            }}
          >
            {author[0]}
          </Avatar>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {author}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  </motion.div>
);

const Testimonials = () => {
  const testimonials = [
    {
      quote: "I already knew the basics of tax preparation, but Sally's coaching helped me focus on the right strategies to grow my business. I'm now fully booked and expanding my team!",
      author: "Emily T."
    },
    {
      quote: "The Business Package took my tax prep business from a side gig to a full-time operation. I learned everything from marketing to managing my first employee. It was the best investment I've made!",
      author: "James D."
    }
  ];

  return (
    <Box sx={{ py: 8, bgcolor: '#f5f5f5' }}>
      <Container maxWidth="lg">
        <Typography
          component="h2"
          variant="h3"
          align="center"
          color="text.primary"
          gutterBottom
          sx={{ mb: 6 }}
        >
          What Others Are Saying About Working With Me
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {testimonials.map((testimonial, index) => (
            <Grid item key={index} xs={12} md={6}>
              <Testimonial {...testimonial} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Testimonials;
